import { Component,  Input, OnInit } from '@angular/core';
import { SeatMap } from "@app/models/seatMap.model";
import { GlobalsService } from "@services/micro/globals.service";
import { SeatDivsInt, SeatmapSectionInt } from "@interfaces/*";

/**
 * Componente que representa el mapa de asientos de un avión.
 * Se encarga de mostrar la distribución de los asientos en base a los segmentos de mapa de asientos proporcionados.
 */
@Component({
    selector: 'app-am-map-plane',
    templateUrl: './am-map-plane.component.html',
    styleUrls: ['./am-map-plane.component.scss'],
    standalone: false
})
export class AmMapPlaneComponent implements OnInit {

    /**
   * Segmentos del mapa de asientos obtenidos desde el servicio global.
   */

  seatMapSegment: Array<SeatMap> = [];
  /**
   * Información de la sección del mapa de asientos proporcionada como entrada.
   */
  @Input() seatDiv: SeatmapSectionInt
    /**
   * Identificación del avión al que pertenece el mapa de asientos.
   */
  @Input() airplane: string;

  /**
   * Clase de la sección del avión.
   */
  class: string;

   /**
   * Lista de divisiones dentro del mapa de asientos.
   */

  divs: SeatDivsInt[] = [];

   /**
   * Estilos CSS dinámicos para la representación de los asientos.
   */
  styles = '';

   /**
   * Filas de asientos organizadas por bloques.
   */

  rowsOfBlock: Array<any> = [];

    /**
   * Índice de la sección dentro del mapa de asientos.
   */
  @Input() index
fares = [
    {
      fareName: 'FIRST_CLASS',
      icon: '/assets/images/planes/seats/B737-9/premier/crown-reclined.svg',
      fareImage: '/assets/images/planes/seats/B737-9/premier/Premier.svg',
      class: 'positionPremierP180',

    },
    {
    fareName: 'FIRST_CLASS180',
    icon: '/assets/images/planes/seats/B737-180/premier/crown-reclined.svg',
    fareImage: '/assets/images/planes/seats/B737-180/premier/Premier_Light.svg',
    class: 'positionPremierP180',

    },
    {
      fareName: 'AM_PLUS',
      icon: '/assets/images/planes/seats/B737-180/amPlus/amplus_logo.svg',
      fareImage: '/assets/images/planes/seats/B737-180/amPlus/amplus.svg',
       class: 'positionPremierP180',
    },
       {
      fareName: 'PREFERRED',
      icon: "/assets/images/planes/seats/B737-180/preferential/preferred_logo.svg",
      fareImage: "/assets/images/planes/seats/B737-180/preferential/Preferential.svg",
       class: 'positionPremierP180',
    },
       {
      fareName: 'EXIT_ROW',
      icon: "/assets/images/planes/seats/B737-180/emergency/emergency_logo.svg",
      fareImage: "/assets/images/planes/seats/B737-180/emergency/emergency.svg",
       class: 'positionPremierP180',
    },
       {
      fareName: 'COACH',
      icon: "/assets/images/planes/seats/B737-180/regular/regular_logo.svg",
      fareImage: "/assets/images/planes/seats/B737-180/regular/Regular.svg",
       class: 'positionPremierP180',
    }
  ];
  constructor(private global: GlobalsService) {
    this.seatMapSegment = this.global.getSeatMapSegmet();

  }

  ngOnInit(): void {
    this.class = this.seatDiv.code.trim();
  }

  getSeats() {

  }
}
